import axios from 'axios';
import * as Sentry from '@sentry/react';

export default (packetId, form) =>
	axios
		.patch(`/forms_rest_api/packet/${packetId}`, form, {
			headers: { 'Content-Type': 'application/json' }
		})
		.catch(error => {
			Sentry.captureException(error);
			throw error;
		});
